





















import VueOptions from '@utils/VueOptions'
import LoadingIndicator from '@components/LoadingIndicator'
import WizardService from '@services/Wizard'
import WizardRoutes from './routes'

settings =
  name: 'AudienceCreativeCreateWizard'

  resources:
    audience_creative:
      resourceName: 'audience_creative'
      slug: 'suppliers/:supplierId/audience_creatives/new'

  vue:
    props: ['options']
    mixins: [WizardService.wizard()]

    components: {
      LoadingIndicator,
    }

    data: ->
      mode: 'CREATE'

    computed:
      member: -> @$store.member
      organizerId: -> @options?.organizerId
      supplierId: -> @options?.supplierId || @member.supplier.id

      wizardRoutes: -> WizardRoutes
      enabledRoutes: -> [@wizardRoutes[0]]
      routeQuery: -> @$route.query

      audienceCreativeData: -> @prime.audience_creative

    methods:
      hiClose: ->
        @$router.push({ name: 'AudienceCreativeListPage' })

      save: ->
        @prime.audience_creative.owner_id ||= @organizerId # for super users
        @saveItem 'prime.audience_creative'

      onSave: (item) ->
        @refetchMember() if @member.audience_creative_count is 0
        # use router replace method to fix behavior of back button
        @$router.replace({
          name: 'AudienceCreativeEditPage',
          params: { audienceCreativeId: item.id },
          query: { step: @wizardRoutes[1].name },
        })

    watch:
      steps: ->
        @navToStepName @routeQuery.step, { skipSave: true } if @routeQuery.step?

export default VueOptions.vue settings
